import { DashTask } from "@/components/dashboard/DashTask";

export function TasksPage() {
  return (
    <div className="mx-auto max-w-4xl py-6">
      <h2 className="mb-4 text-xl font-semibold">Tasks</h2>
      <DashTask />
    </div>
  );
}
